import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/membership", label: "Membership" },
  { to: "/booking", label: "Book" },
  { to: "/ai-quote", label: "AI Quote" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = React.useState(false);

  return (
    <header
      className="sticky top-0 inset-x-0 z-50 glass-nav"
      data-testid="navbar"
    >
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <img
            src="https://customer-assets.emergentagent.com/job_premium-clean-atl/artifacts/x1iqqas7_ShoNics%20Logo.jpg"
            alt="ShoNics Kleaning Solutions"
            className="h-12 md:h-14 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(" ","-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${isActive ? "text-[#0B5D3B] font-semibold" : "text-[#111]/70 hover:text-[#0B5D3B]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href="tel:9432450462" className="flex items-center gap-2 text-sm text-[#111]/80 hover:text-[#0B5D3B]" data-testid="navbar-phone">
            <Phone className="w-4 h-4" strokeWidth={1.5} /> 943-245-0462
          </a>
          {user ? (
            <>
              <Link
                to={user.role === "admin" ? "/admin" : "/dashboard"}
                className="text-sm font-medium text-[#0B5D3B]"
                data-testid="navbar-dashboard-link"
              >
                {user.role === "admin" ? "Admin" : "Dashboard"}
              </Link>
              <button
                onClick={() => { logout(); nav("/"); }}
                className="text-sm text-[#111]/70 hover:text-[#111]"
                data-testid="navbar-logout"
              >
                Sign out
              </button>
            </>
          ) : (
            <Link to="/login" className="text-sm font-medium text-[#111]" data-testid="navbar-login">Sign in</Link>
          )}
          <Link to="/booking" className="btn-primary text-sm py-2.5 px-5" data-testid="navbar-book-now">Book Now</Link>
        </div>

        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="navbar-mobile-toggle">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-white/95 backdrop-blur-xl">
          <div className="container-x py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)}
                className="text-sm py-2"
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(" ","-")}`}>
                {l.label}
              </NavLink>
            ))}
            <a href="tel:9432450462" className="text-sm py-2 text-[#0B5D3B]">943-245-0462</a>
            {user ? (
              <Link to={user.role === "admin" ? "/admin" : "/dashboard"} className="btn-primary text-sm" onClick={() => setOpen(false)}>
                {user.role === "admin" ? "Admin" : "Dashboard"}
              </Link>
            ) : (
              <Link to="/login" className="btn-secondary text-sm" onClick={() => setOpen(false)}>Sign in</Link>
            )}
            <Link to="/booking" className="btn-primary text-sm" onClick={() => setOpen(false)}>Book Now</Link>
          </div>
        </div>
      )}
    </header>
  );
}
